import { render, staticRenderFns } from "./XmlList.vue?vue&type=template&id=52f2e8ef&scoped=true&"
import script from "./XmlList.vue?vue&type=script&lang=js&"
export * from "./XmlList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f2e8ef",
  null
  
)

export default component.exports